import React from 'react';
import PropTypes from 'prop-types';
import StudentStudyQualitySummary from './StudentStudyQualitySummary';
import { toJS } from 'mobx';
import { StudentStudyQualityListService } from '../../services/CustomerSuccessKpiListService';
import { observer } from 'mobx-react';
import { get } from 'lodash';

class StudentStudyQualitySummaryContainer extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentStudyQualityListService.load();
  }

  render() {
    const data = toJS(StudentStudyQualityListService.getSummaryByType(this.props.type, this.props.typeId));
    return (
      <StudentStudyQualitySummary
        isLoading={
          StudentStudyQualityListService.fetchCurrent.fetching || StudentStudyQualityListService.fetchPrevious.fetching
        }
        currentValue={get(data, 'current')}
        previousValue={get(data, 'previous')}
        standardDeviationValue={get(data, 'currentStandardDeviation')}
        formatter={StudentStudyQualityListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentStudyQualitySummaryContainer);
